exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Resumo.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d13cae2c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/cadastros/maranhao/processoFisico/components/Resumo.vue
// module id = 8TDu
// module chunks = 12